export const propertyFields = {
    responsibleId: null,
    responsibleFirstname: null,
    responsibleLastname: null,
    responsibleEmail: null,
    complianceSurveyOnly: null,
    town: null,
    street: null,
    numberStreet: null,
    zipCode: null,
    creationDate: null,
    propertyType: null,
    propertyTypeOther: null,
    contacts: [],
};
